import React, { useState, useEffect } from 'react'
import AceEditor from 'react-ace'
import 'brace/mode/json'
import 'brace/theme/monokai'

import { Button } from '../../common/components/button'
import { Modal } from '../../common/components/modal'

import { useStyles } from './manual-block-editor.style'

export const ManualBlockEditor = function ({ block, onChange = () => {} }) {
  const classes = useStyles()

  const [isModalOpen, setIsModalOpen] = useState()
  const [errorMessage, setErrorMessage] = useState('')
  const [json, setJson] = useState(getInitialBlockConfig())

  useEffect(() => {
    setJson(getInitialBlockConfig())
  }, [block])

  function getInitialBlockConfig () {
    return JSON.stringify(block, null, 2)
  }

  function handleEditConfiguration () {
    setIsModalOpen(true)
  }

  function handleModalClose () {
    setJson(getInitialBlockConfig())
    setIsModalOpen(false)
    setErrorMessage('')
  }

  function handleManualUpdate () {
    onChange(JSON.parse(json))
    setIsModalOpen(false)
    setErrorMessage('')
  }

  function onManualChange (updatedJson) {
    setJson(updatedJson)

    try {
      const updatedBlock = JSON.parse(updatedJson)

      if (updatedBlock.key !== block.key) {
        setErrorMessage('Block key cannot be changed')
        return
      }

      setErrorMessage('')
    } catch (e) {
      setErrorMessage(e.message)
    }
  }

  return <>
    <Button variant="secondary" onClick={handleEditConfiguration}>Manually Edit Configuration</Button>
    <Modal isOpen={isModalOpen} onClose={handleModalClose} title="Configuration" enableOverlayClick={false}
      footer={<>
        {errorMessage &&
          <div className={classes.errorMessageContainer}>
            <div className="font-icon-error" />
            <div className={classes.errorMessageText}>
              {errorMessage}
            </div>
          </div>
        }
        <Button variant="secondary" onClick={handleManualUpdate} disabled={!!errorMessage}>Update</Button>
      </>}>
      <div className={classes.container}>
        <AceEditor
          mode="json"
          theme="monokai"
          name="modal-json-editor"
          width="100%"
          height="100%"
          value={json}
          onChange={onManualChange}
          tabSize={2}
        />
      </div>
    </Modal>
  </>
}
